import {Component, h, Fragment} from "preact";
import {Modal} from "../../_common/components/modal";
import {t} from "../../_i18n";
import {fetchApplications} from "../../_rx/jobs/actions";
import {connect} from "react-redux";
import {C, E} from "../../_common/layout";

function formatPhoneNumber(phoneNumberString: string) {
    const match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{3})$/)
    if (match) {
        return match[1] + ' ' + match[2] + ' ' + match[3]
    }
    return phoneNumberString
}

type PropsReact = {
    candidateReducer: any,
    id: any
}


class View extends Component<PropsReact, { }> {
    constructor(props: any) {
        super(props);
    }

    render = ({candidateReducer, id}: PropsReact) => (candidateReducer) && <Modal id={id} title={t('Información de contacto')} className="md-no-fullscreen">
            <hr className="separator-xxs"/>
            <div className="in-modal-scroll">
                {(candidateReducer.candidate) &&
                    <E className='m-x2-bottom'>
                        {(candidateReducer.candidate.fullAddress) && <Fragment>
                            <div>{t('Dirección')}</div>
                            <span className='font-medium'>{candidateReducer.candidate.fullAddress}</span>
                            <hr className="separator-xxs"/>
                        </Fragment>}
                        {(candidateReducer.candidate.phone) && <Fragment>
                            <div>{t('Teléfono')}</div>
                            <span className='font-medium'>{formatPhoneNumber(candidateReducer.candidate.phone)}</span>
                            <hr className="separator-xxs"/>
                        </Fragment>}
                        {(candidateReducer.candidate.email) && <Fragment>
                            <div>{t('Correo electrónico')}</div>
                            <span className='font-medium'>{candidateReducer.candidate.email}</span>
                        </Fragment>}
                    </E>
                }
            </div>
    </Modal>

}

const ConnectedView: any = connect(
    ({fixtures, candidateReducer}:any)=>({fixtures, candidateReducer}), {fetchApplications})(View as any);


export default ({id}: any) =>
    <ConnectedView id={id}/>
;